import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7A7B1",
      d: "M4.673 4.05c2.726-1.934 6.623-1.776 9.144.375 2.565 2.187 2.916 5.763.806 8.322-1.988 2.411-5.571 3.206-8.555 1.962l-.163-.07-3.06.65-.052.01-.077.006-.08-.003-.03-.003-.077-.014-.074-.024-.07-.03-.053-.03-.075-.054-.057-.052-.051-.058-.037-.052-.046-.08-.029-.075-.022-.079-.009-.052L2 14.622l.003-.08.003-.03.014-.077.016-.05.804-2.414-.015-.026c-1.546-2.62-.846-5.87 1.686-7.777z",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }